export const appBarStyles = {
  background: "inherit",
  boxShadow: "none",
  padding: "0 16px",
  fontFamily: "'Space Grotesk', serif",
  transition: "background-color 0.3s ease-in-out",
  "@media (maxWidth:600px)": {
    padding: "0 8px", // Уменьшаем отступы на мобильных устройствах
  },
};

export const toolbarStyles = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "0",
  "@media (maxWidth:600px)": {
    padding: "8px 0", // Меньше отступов на мобильных
  },
};

export const logoStyles = {
  display: "flex",
  alignItems: "center",
  maxWidth: "180px",
  "@media (maxWidth:600px)": {
    maxWidth: "120px", // Логотип уменьшается на мобильных
  },
  "@media (maxWidth:320px)": {
    maxWidth: "100px", // Логотип еще меньше на маленьких экранах
  },
};

export const iconButtonStyles = {
  fontSize: "5rem",
  color: "#1e88e5",
  transition: "color 0.3s ease",
  "&:hover": {
    color: "#1565c0", // При наведении цвет меняется
  },
  "@media (maxWidth:600px)": {
    fontSize: "4rem", // Уменьшаем размер иконки на мобильных
  },
};

export const menuButtonStyles = (theme) => ({
  fontFamily: "'Space Grotesk', serif",
  textTransform: "none",
  marginBottom: "12px",
  fontSize: "16px",
  fontWeight: "500",
  transition: "color 0.3s ease, transform 0.3s ease, text-shadow 0.3s ease",
  color: theme.palette.mode === "light" ? "#1e88e5" : "#90caf9", // светлый для светлой темы, светлый голубой для темной темы
  '&:hover': {
    color: theme.palette.mode === "light" ? "#1565c0" : "#64b5f6", // Меняем цвет на более темный при наведении
    transform: "scale(1.05)",
    textShadow: theme.palette.mode === "light" 
      ? "0 0 10px #1e88e5, 0 0 20px #1e88e5, 0 0 30px #1e88e5"
      : "0 0 10px #90caf9, 0 0 20px #90caf9, 0 0 30px #90caf9", // Свечение для обеих тем
  },
  '&:active': {
    transform: "scale(1)",
    textShadow: theme.palette.mode === "light"
      ? "0 0 5px #1565c0, 0 0 10px #1565c0"
      : "0 0 5px #64b5f6, 0 0 10px #64b5f6", // Тень для активного состояния
  },
  "@media (maxWidth:600px)": {
    fontSize: "14px",
  },
});


export const drawerStyles = {
  width: 250,
  flexShrink: 0,
  "& .MuiDrawer-paper": {
    width: 250,
    backgroundColor: "#fff",
    paddingTop: 2,
    boxShadow: "none",
    borderRadius: "8px 0 0 8px",
    transition: "transform 0.3s ease",
    transform: "translateX(100%)",
    "&.MuiDrawer-open": {
      transform: "translateX(0)",
    },
  },
  "@media (maxWidth:600px)": {
    width: "200px", // Уменьшаем ширину drawer на мобильных
  },
};

export const drawerBoxStyles = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  padding: "20px",
  fontFamily: "'Raleway', serif",
  "@media (maxWidth:600px)": {
    padding: "10px", // Меньше отступов на мобильных
  },
};

export const iconBtnStyles = {
  fontSize: "2rem",
  color: "black",
  alignSelf: "flex-end",
  "@media (maxWidth:600px)": {
    fontSize: "1.5rem", // Меньше иконки на мобильных
  },
};

export const logoImageStyles = {
  width: "40px", // размер изображения
  height: "40px", // пропорции изображения
  objectFit: "contain", // изображение будет вписываться по пропорциям
  "@media (maxWidth:600px)": {
    width: "35px", // Уменьшаем изображение на мобильных
    height: "35px", // Пропорции тоже меняются
  },
};
